shadow$provide[496] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, library:{enumerable:true, get:function() {
  return library;
}}});
const library = function(language, snippets, load) {
  let callback = null;
  let used = {};
  if (snippets != null) {
    if (typeof snippets === "function") {
      callback = name => load(language, name, snippets(name));
    } else if (typeof snippets === "object") {
      callback = function(name) {
        if (snippets[name] == null) {
          throw new Error(`Unknown snippet \`${name}\``);
        }
        return load(language, name, snippets[name]);
      };
    }
  }
  const inline = code => load(language, "", code);
  if (callback == null) {
    return inline;
  }
  const fetch = function(name) {
    if (name.match(/[{;]/)) {
      return inline(name);
    }
    used[name] = true;
    return callback(name);
  };
  fetch.used = function(_used) {
    if (_used == null) {
      _used = used;
    }
    return used = _used;
  };
  return fetch;
};

};